module.exports = __webpack_public_path__ + "img/logo-scuro.445c4eba.png";